import DropDown, { DropDownProps } from 'components/common/Selectable/DropDown';

const ParameterDropdown = ({ selectValue, value, filterData, setFilteredData }: DropDownProps) => (
  <DropDown
    selectValue={selectValue}
    overrideStyles={{
      control: {
        bgColor: 'white',
        minW: 175,
      },
    }}
    value={value}
    filterData={filterData}
    setFilteredData={setFilteredData}
  />
);

export default ParameterDropdown;
